module.exports = __webpack_public_path__ + "static/media/edit-pencil.411d5265.svg";